<template>
  <div class="my-3">
    <v-expand-transition>
      <v-row>

        <v-col md="3">
          <div @click="$emit('toggleStatus', 30)">
            <Indicador
              titulo="Pré acordos"
              :valor="indicadores.preAcordos"
              icone="$alertCircleCheckOutline"
              :class="{ active: statusIndicadores.includes(30) }"
            />
          </div>
        </v-col>
        <v-col md="3">
          <div @click="$emit('toggleStatus', 29)">
            <Indicador
              titulo="Espaço Reservado"
              :valor="indicadores.espacoReservado"
              icone="$circleSlice"
              :class="{ active: statusIndicadores.includes(29) }"
            />
          </div>
        </v-col>
        <v-col md="3">
          <div @click="$emit('toggleStatus', 15)">
            <Indicador
              titulo="Aguardando Gestão"
              :valor="indicadores.aguardandoGestao"
              icone="$documentAlertOutline"
              :class="{ active: statusIndicadores.includes(15) }"
            />
          </div>
        </v-col>
        <v-col md="3">
          <div @click="$emit('toggleStatus', 16)">
            <Indicador
              titulo="Contratos Emitidos"
              :valor="indicadores.contratosEmitidos"
              icone="$documentCheck"
              :class="{ active: statusIndicadores.includes(16) }"
            />
          </div>
        </v-col>
        <v-col md="3">
          <div @click="$emit('toggleStatus', 28)">
            <Indicador
              titulo="Acordos Cancelados"
              :valor="indicadores.acordosCancelados"
              icone="$documentRemove"
              :class="{ active: statusIndicadores.includes(28) }"
            />
          </div>
        </v-col>
      </v-row>
    </v-expand-transition>
  </div>
</template>

<script>
import Indicador from "@/views/acordo/_components/Indicador.vue";
export default {
  name: "IndicadoresCampanhaCircuito",
  components: { Indicador },
  props: {
    indicadores: {
      type: Object,
      default: () => ({})
    },
    statusIndicadores: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.my-3 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>
